import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

const Icon = ({ name, size, alt, styleModifier = '', styleModifierObj = {}, isFlipped }) => {
  const isSize = size ? `is-${size}` : ''
  const flippedClass = isFlipped ? styles['is-flipped'] : ''
  return (
    <Fragment>
      <svg
        className={`${styles.icon} ${styles[isSize]} ${styleModifier} ${flippedClass} ${styles[`is-${name}`]}`}
        style={styleModifierObj}
        focusable='false'
        viewBox='0 0 1 1'
        aria-hidden='true'>
        <use href={`#sprite_svg__${name}`} />
      </svg>
      {alt ? <span className='is-sr-only'>{alt}</span> : null}
    </Fragment>
  )
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  alt: PropTypes.string,
  styleModifier: PropTypes.string,
  styleModifierObj: PropTypes.object,
  isFlipped: PropTypes.bool
}

Icon.defaultProps = {
  name: '',
  size: '',
  alt: '',
  styleModifier: '',
  styleModifierObj: {},
  isFlipped: false
}

export default Icon
